import { useRuntimeThemeLifecycle } from '@emporion/ui'
import {
  applyThemeToDocument,
  fetchPublicRuntimeTheme,
  getDefaultRuntimeTheme,
  readCachedRuntimeTheme,
} from '../themeRuntime'

export const useShopThemeRuntime = () =>
  useRuntimeThemeLifecycle({
    readCachedTheme: readCachedRuntimeTheme,
    applyTheme: applyThemeToDocument,
    fetchTheme: fetchPublicRuntimeTheme,
    getFallbackTheme: getDefaultRuntimeTheme,
  })
